import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import Message from 'carbon-react/lib/components/message';
import Typography from 'carbon-react/lib/components/typography';

export interface SfaErrorMessageProps {
  title?: string;
  children?: ReactNode;
}

export const SfaErrorMessage = ({ title, children }: SfaErrorMessageProps) => {
  const intl = useIntl();
  const defaultTitle = intl.formatMessage({
    id: 'common.something_went_wrong',
    defaultMessage: 'Something went wrong'
  });

  return (
    <Message open variant="error" title={<Typography variant="strong">{title || defaultTitle}</Typography>} mb={3}>
      <Typography mb={0}>{children}</Typography>
    </Message>
  );
};
